<template>
    <div>
      <img class="comicsImg animate__animated" src="../assets/comic-book-click.png" :style="{ top: (block.top-256) + 'px', left: block.left + 'px', }" />
    </div>
  </template>
  
  <script>
  import { onMounted } from 'vue'
  export default {
    props: ['block'],
    setup(props){
    
    const startAnimation = ()=> {
        console.log(props.block)
      setInterval(() => {
        const comicsImg = document.getElementsByClassName('comicsImg')
        comicsImg[0].classList.add('animate__bounce')
          setTimeout(() => {
            comicsImg[0].classList.remove('animate__bounce')
          }, 1000)
        }, 5000)
    }
    onMounted(startAnimation)
        return{

        }
    }
  }
  </script>
  <style scoped>
.comicsImg{
    position: absolute;
    z-index: 9999;
    height: 100px;
    width: auto;
}

</style>